import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('Industry %{industry} not found').i__({
        industry: inputValue,
      })
    : __('Search for a industry');

const ReactSelectIndustries = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    loadOptionsUrl={Routes.search_industries_path({ format: 'json' })}
    placeholder={placeholder || __('Industry')}
    noOptionsMessage={noOptionsMessage}
    multiple={multiple || isMulti}
  />
);

ReactSelectIndustries.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectIndustries;
